import React, { Component } from "react";

//Import CSS
import "./header.css";

//Import internal components
import HeaderDesktop from "./header-desktop";
import HeaderMobile from "./header-mobile";
import HeaderFaq from "../../faq/header";

//Import external components
import Swal from "sweetalert2";

//Import image

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_loged: false,
      token: "",
      isMobile: window.innerWidth < 1280,
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.handleResize);
    var token = await sessionStorage.getItem("token");
    if (token) {
      this.setState({ is_loged: true });
    }

    if (sessionStorage.getItem("token") != null) {
      const requestOptions = {
        method: "POST",
        body: JSON.stringify({ token: sessionStorage.getItem("token") }),
      };
      fetch(process.env.REACT_APP_LABS_API + "validate_user.php", requestOptions)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.status !== 200) {
            Swal.fire({
              text: "Sessão expirada!",
              icon: "warning",
              title: "Aviso",
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonColor: "#00518b",
              confirmButtonText: "Ok!",
            }).then(result => {
              if (result.value) {
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("session_token");
                sessionStorage.removeItem("grant_token");
                localStorage.removeItem("token");
                localStorage.removeItem("session_token");
                localStorage.removeItem("grant_token");
                this.setState({
                  redirect: true,
                });
              }
            });
          }
        });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth < 1280;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  render() {
    if (this.state.redirect) {
      window.location.href = "/";
    }
    if (this.state.is_loged) {
      const { isMobile } = this.state;
      return (
        <div>
          <header className="header" id="main-header">
            <div className="header-desktop-wrapper" style={{ display: isMobile ? 'none' : 'block' }}>
              <HeaderDesktop lista_multi_contas={this.props.lista_multi_contas} />
            </div>
            <div className="header-mobile-wrapper" style={{ display: isMobile ? 'block' : 'none' }}>
              <HeaderMobile lista_multi_contas={this.props.lista_multi_contas} />
            </div>
          </header>
        </div>
      );
    } else {
      return (
        <div>
          <header className="header" id="main-header">
            <HeaderFaq />
          </header>
        </div>
      );
    }
  }
}

export default Header;
